import { BRANDS_LIST } from '~/constants/brands';

import * as S from './BrandsList.styled';

export const BrandsList = () => (
  <S.Container>
    {BRANDS_LIST.map(({ logoUrl, alt }) => (
      <S.BrandLogo key={alt} src={logoUrl} alt={alt} />
    ))}
  </S.Container>
);
